module.exports = __webpack_public_path__ + "static/media/redirect.782c9f18.svg";